export default "__VITE_ASSET__D7jMo_hi__"